import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';








@Component({
  selector: 'app-licencias',
  templateUrl: './licencias.component.html',
  styleUrls: ['./licencias.component.css']
})
export class LicenciasComponent implements OnInit {

















completed = false;
  title = 'frontend';
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  showcompraLicencia = false;
  stepper: any;
  constructor(private _formBuilder: FormBuilder
              ) { }

  ngOnInit() {

    // localStorage.removeItem('token');
    // localStorage.removeItem('idsolicitante');
    localStorage.clear();

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

  }

  muestraprocesolicencia() {
    this.showcompraLicencia = true;
  }



   displayCounter(count) {
    this.completed = true;

 }





}
